import React from 'react';
import "./TopBar.sass";
import {FiArrowLeft, FiMoreHorizontal} from 'react-icons/fi';
import Config from "../../../config";

const TopBar = ({back}) => {

    return (
            <div className="top-bar uk-flex uk-flex-between uk-flex-middle">
                <div className="nav">
                    <div className="button mobile" onClick={back}>
                        <FiArrowLeft/>
                    </div>
                </div>
                <div className="nav">
                    {Config.demo && <div className="uk-inline">
                        <div className="button" type="button">
                            <FiMoreHorizontal/>
                        </div>
                        <div data-uk-dropdown="mode: click; offset: 5; boundary: .top-bar; pos: bottom-right">
                        </div>
                    </div>}
                </div>
            </div>
    );
}

export default TopBar;
